<template>
  <div class="promotion-guidelines">
    <!-- 头部区域 -->
    <div class="header">
      <div class="header-left">
        <button class="back-btn" @click="goBack">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
        <div class="title">推广规范</div>
      </div>
    </div>

    <!-- 主要内容 -->
    <div class="content-container">
      <div class="rule-item">
        <div class="rule-number">1</div>
        <div class="rule-content">
          用户如果没有通过你的专属链接下单,将导致推广跟踪失败,包括用户通过返利软件下单,或者用户在下单过程中使用其他推广者的超级红包、礼金等;
        </div>
      </div>

      <div class="rule-item">
        <div class="rule-number">2</div>
        <div class="rule-content">
          避免代客下单行为,同一个顾客多次购买同一个商品,有可能会触发京东风控,导致订单被判断为违规订单。同时下单账号也有可能被判定为异常账号,会影响到该下单账号后续产生的推广佣金;
        </div>
      </div>

      <div class="rule-item">
        <div class="rule-number">3</div>
        <div class="rule-content">
          引流和销售环节需遵守品牌规定,下面是品牌红线规定,一旦被查实,视严重程度,将给于罚款/关停小程序推广权限/追索推广佣金的处罚:
        </div>
      </div>


      <div class="sub-rules">
        <div class="sub-rule">
          <span class="sub-rule-number">(1)</span>
          <span class="sub-rule-content">
            引流销售环节中侵犯他人利益,包括去品牌方/同行的帖子下面通过评论、私聊等行为截流,在同行群里偷粉/炸群等行为。
          </span>
        </div>

        <div class="sub-rule">
          <span class="sub-rule-number">(2)</span>
          <span class="sub-rule-content">
            在规定的团购权益以外,违反品牌规定,私自给用户返现。
          </span>
        </div>

        <div class="sub-rule">
          <span class="sub-rule-number">(3)</span>
          <span class="sub-rule-content">
            违反品牌规定引流,包括不限于在小红书、抖音等公域内容渠道直接透出团购到手价,或话术违反品牌侧规定。
          </span>
        </div>

        <div class="sub-rule">
          <span class="sub-rule-number">(4)</span>
          <span class="sub-rule-content">
            未获得品牌允许,私自将团购商品上架到京东/淘宝/拼多多/抖音等公域电商平台销售。
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PromotionGuidelines',
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.promotion-guidelines {
  height: 100vh;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 10px;
  box-sizing: border-box;
}

.content-container {
  flex: 1;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  overflow-x: hidden;
}

.content {
  padding: 30px;
}

.header {
  background: linear-gradient(135deg, #42b983, #369870);
  color: white;
  padding: 4px;
  margin-bottom: 10px;
  flex-shrink: 0;
  border-radius: 12px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.back-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  color: white;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.back-btn svg {
  width: 20px;
  height: 20px;
}

.title {
  font-size: 18px;
  font-weight: 600;
  color: white;
}

.rule-item {
  display: flex;
  margin-bottom: 20px;
  align-items: flex-start;
}

.rule-number {
  background: #42b983;
  color: white;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-right: 15px;
  flex-shrink: 0;
}

.rule-content {
  flex: 1;
  line-height: 1.6;
  color: #333;
  font-size: 16px;
}

.sub-rules {
  margin-top: 20px;
  padding-left: 20px;
}

.sub-rule {
  display: flex;
  margin-bottom: 15px;
  align-items: flex-start;
}

.sub-rule-number {
  color: #e74c3c;
  font-weight: bold;
  margin-right: 10px;
  flex-shrink: 0;
}

.sub-rule-content {
  flex: 1;
  line-height: 1.6;
  color: #555;
  font-size: 15px;
}


/* 移动端优化 */
@media (max-width: 768px) {

  .header {
    padding: 4px;
  }

  .content-container {
    padding: 15px;
  }
  
  .content {
    padding: 20px;
  }


  .title {
    font-size: 18px;
  }

  .rule-content {
    font-size: 15px;
  }

  .sub-rule-content {
    font-size: 14px;
  }

  .sub-rules {
    padding-left: 10px;
  }
}
</style>
